<div class="sca-list">
  <ng-content></ng-content>
</div>
